import React, { createContext, useContext, useState, useEffect } from "react";
import { auth } from "../firebase/firebase";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(
    () => JSON.parse(localStorage.getItem("isOtpVerified")) || false
  );
  const [loading, setLoading] = useState(true); // Prevents flickering

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user && isOtpVerified) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
      setLoading(false); // Done loading
    });

    return () => unsubscribe();
  }, [isOtpVerified]);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    auth.signOut();
    setIsAuthenticated(false);
    setIsOtpVerified(false);
    localStorage.removeItem("isOtpVerified");
  };

  const verifyOtp = () => {
    setIsOtpVerified(true);
    localStorage.setItem("isOtpVerified", JSON.stringify(true));
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        isOtpVerified,
        setIsOtpVerified: verifyOtp,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
